import { AiOutlineArrowLeft, AiOutlineArrowRight } from 'react-icons/ai';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import DynamicField from './DynamicField';
import styles from './index.module.less';

import { ActionButton, Alert, IntlMessage } from '$HVUI';
import FormButton from '$Molecules/Buttons/FormButton';

const mapStateToProps = (state, ownProps, formName) => {
    return Object.assign({}, ownProps, {
        formName
    });
};
function DynamicForm(props) {
    const {
        activeForm,
        lastSection,
        activeSectionIndex,
        asyncValidating: partialIsSubmitting,
        change,
        customError,
        decrementActiveSection,
        fields,
        formName,
        handleSubmit,
        invalid,
        resetForm,
        submit,
        submitting,
        valid
    } = props;

    const renderFields = () => {
        return fields.map(field => {
            return (
                <DynamicField
                    change={change}
                    key={field.name}
                    field={field}
                    partialIsSubmitting={partialIsSubmitting}
                    invalid={invalid}
                    formName={formName}
                    language={props.language}
                />
            );
        });
    };

    const { completedUpToIndex, previousForm, nextForm } = activeForm || {};

    const validPrevious = previousForm && previousForm.id !== activeForm.id;
    const showBack = activeSectionIndex > 0 || validPrevious;
    const nextExists = completedUpToIndex >= activeSectionIndex || nextForm;
    const showForward = valid && nextExists;
    const continueButtonText = (
        <IntlMessage id="all.continue" defaultMessage="Continue" />
    );

    return (
        <div className={styles['formEditContainer']} id={'dynamicContainer'}>
            {showBack && (
                <div
                    style={{
                        position: 'absolute',
                        left: '16px',
                        top: '16px'
                    }}
                >
                    <ActionButton
                        id="back-button"
                        icon={AiOutlineArrowLeft}
                        style={{
                            height: '35px',
                            width: '35px',
                            border: 'none',
                            background: 'none'
                        }}
                        text="Back"
                        onClick={() => {
                            decrementActiveSection();
                        }}
                    />
                </div>
            )}
            {showForward && (
                <div
                    style={{
                        position: 'absolute',
                        right: '16px',
                        top: '16px'
                    }}
                >
                    <ActionButton
                        icon={AiOutlineArrowRight}
                        text="Next"
                        id="next-button"
                        style={{
                            height: '35px',
                            width: '35px',
                            border: 'none',
                            background: 'none'
                        }}
                        onClick={() => {
                            if (activeSectionIndex !== lastSection) {
                                document
                                    .getElementById('top-partial-trigger')
                                    .focus();
                                document
                                    .getElementById('top-partial-trigger')
                                    .blur();
                            } else {
                                return submit();
                            }
                        }}
                    />
                </div>
            )}
            <div className={styles['formEdit']}>
                <form
                    onSubmit={values => {
                        handleSubmit(values, resetForm);
                    }}
                    data-complete={!invalid && !submitting}
                    className={[
                        styles['dynamicForm'],
                        styles['form-body']
                    ].join(' ')}
                >
                    {activeSectionIndex !== lastSection && (
                        <div className={styles['trigger-container']}>
                            <DynamicField
                                change={change}
                                formName={formName}
                                field={{
                                    id: 'top-partial-trigger',
                                    name: 'top-partial-trigger',
                                    type: 'text'
                                }}
                            />
                        </div>
                    )}
                    {customError && (
                        <Alert type="error" message={customError} showIcon />
                    )}
                    {renderFields()}
                    {/** Hidden field for async blur partial trigger **/}
                    {activeSectionIndex !== lastSection && (
                        <div className={styles['trigger-container']}>
                            <DynamicField
                                change={change}
                                formName={formName}
                                field={{
                                    id: 'bottom-partial-trigger',
                                    name: 'bottom-partial-trigger',
                                    type: 'text'
                                }}
                            />
                        </div>
                    )}
                    {activeSectionIndex === lastSection && (
                        <FormButton
                            {...props}
                            element="button"
                            text={continueButtonText}
                            showCancel={false}
                            className={styles['form-submit']}
                        />
                    )}
                </form>
            </div>
        </div>
    );
}

export const submitPartialEntry = (values, _dispatch, props) => {
    return props.submitPartial(values);
};

const shouldAsyncValidate = params => {
    return params.trigger === 'blur';
};

const DynamicFormConnected = formName => {
    return connect((state, ownProps) =>
        mapStateToProps(state, ownProps, formName)
    )(
        reduxForm({
            form: formName,
            // We are using redux-form's asyncValidate functionality
            // to submit a single "page" of a form, known as a partial.
            // This is really a submit, not a true validation,
            // so the name is a little confusing.
            // It is triggered when we blur the hidden field.
            asyncValidate: submitPartialEntry,
            asyncBlurFields: ['top-partial-trigger', 'bottom-partial-trigger'],
            shouldAsyncValidate
        })(DynamicForm)
    );
};

export default DynamicFormConnected;

export const disconnected = DynamicForm;
